import React from 'react';
import { Award, Shield, TrendingUp } from 'lucide-react';

const TrustSection = () => {
  const features = [
    {
      icon: Award,
      title: 'Science-Backed',
      description: 'Formulated with precision. Every ingredient serves a purpose.'
    },
    {
      icon: Shield,
      title: 'Quality Assured',
      description: 'Same formula for everyone. No shortcuts, no compromises.'
    },
    {
      icon: TrendingUp,
      title: 'Results You Feel',
      description: 'Energy that lasts. Focus that stays. Days that work.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C2416] mb-6">
            Nutrition that<br />actually delivers.
          </h2>
          <p className="text-xl text-[#5C4033] max-w-3xl mx-auto">
            No gimmicks. No empty promises. Just real ingredients, real nutrition, 
            and real results you can feel from your first serving.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl text-center hover:shadow-lg transition-shadow"
              >
                <div className="mb-6 flex justify-center">
                  <div className="w-16 h-16 bg-[#8B6F47] rounded-full flex items-center justify-center">
                    <Icon className="text-white" size={32} />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-[#2C2416] mb-3">
                  {feature.title}
                </h3>
                <p className="text-[#5C4033]">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;